import React from "react";
import {FieldTableCellProps, getTableCellStyle} from "../../../../../render/table/table-cell";


export default function FieldProjectProgressItems_TableCell(props: FieldTableCellProps){

    const minWidth = 80


    const value = !!props.listItem.project.progressSubItems.total ? gd.utils.floorToDecimals(100 * props.listItem.task.progressSubItems.done/props.listItem.task.progressSubItems.total, 0) : null
    const classes = Classes("cell-flex ui5-txt-less-important-small", props.column.id)
    const style = getTableCellStyle(props)
    const progressClasses = Classes("ui5-progress", "in-ui5-field", {
        // "flex-row-center-center": style.width < minWidth
    });


    return(
        <div
            className={classes}
            style={style}
        >
            {!_.isNil(value) && (
                <div className={progressClasses}>
                    {style.width > minWidth && (
                        <div className="progress-bg">
                            {!!value && <div className="progress-line" style={{width: '{0}%'.f(value)}}/>}
                        </div>
                    )}

                    <div
                        className={Classes(style.width > minWidth && "progress-label", "ui5-txt-less-important-small", "txt-truncate")}>
                        {props.listItem.project.progressSubItems.done + "/" + props.listItem.project.progressSubItems.total}
                    </div>
                </div>
            )}
        </div>
    )
}
